import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './styles/app.css';
import '@matix/ui/login-styles';
import '@matix/ui/setup-styles';
import { App } from './App';
import { LanguageProvider } from './lib/lang';
import { useAuthStore } from './lib/authStore';

// SSO handoff: the cashier opens this app with #sso=<jwt>. Adopt it (hydrate
// session via /me) and strip it from the URL so the token isn't left behind.
// Otherwise, re-seed any stored session token before first render.
const ssoMatch = window.location.hash.match(/[#&]sso=([^&]+)/);
if (ssoMatch?.[1]) {
  history.replaceState(null, '', window.location.pathname + window.location.search);
  void useAuthStore.getState().adoptToken(decodeURIComponent(ssoMatch[1]));
} else {
  useAuthStore.getState().init();
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 10_000, refetchOnWindowFocus: false, retry: 1 } },
});

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
